import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@uncinc/uncinc-react-kitchen-sink';

const DownloadBlock = ({ entity }) => {
  const { t } = useTranslation();
  const fileUrl = entity.getIn(['field_pdf_file', 0, 'source'], null);

  return (
    <Button
      className="SecondaryMenu__item__link Button--cta"
      href={fileUrl}
    >
      {t('annual_report.annual_report')}
      <i className="icon icon-download" />
    </Button>
  );
};

export default DownloadBlock;
